const ModifyAcquirerAction = "MODIFY_ACQUIRER";
const SaveAcquirerAction = "SAVE_ACQUIRER";
const ListAcquirersAction = "LIST_ACQUIRERS";
const Waiting = "WAITNG_ACQUIRERS";
const MerchantCategotyCodeAction = "CATEGORY_CODES_MERCHANT";
const DeleteAcquirerAction = "DELETE_ACQUIRER";

const initialState = {
    list: [],
    nowWainting: false,
    editing: null,
};
export const actionCreators = {
    /**
     * 代表加盟店一覧を取得
     */
    listAcquirers: (token) => async (dispatch) => {
        const routeurl = `api/user/merchants/list_acquirer`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const list = resp.result;
                    dispatch({ type: ListAcquirersAction, list });
                    return list;
                } else {
                    throw new Error(resp.error_message || '加盟店一覧取得に失敗しました。');
                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 代表加盟店を申請
     */
    apply: (token, acquirer) => async (dispatch) => {
        var routeurl = `api/user/merchants/apply_acquirer`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(acquirer)
            })
            var addNew = true;

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: SaveAcquirerAction, acquirer: resp.result, addNew });
                    return resp.result;

                } else {

                    throw new Error(resp.error_message || '申請に失敗しました。');

                }
            } else {
                throw new Error('申請に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 代表加盟店情報を編集します。
     */
    modifyAcquirer: (acquirer) => async (dispatch) => {
        dispatch({ type: ModifyAcquirerAction, acquirer, nowWainting: false });
    },

    /**
     * 編集を保存します。
     */
    save: (token, acquirer) => async (dispatch) => {
        var routeurl = `api/user/merchants`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(acquirer)
            })

            var addNew = false;

            // IDがまだないものは新規登録とみなす
            if (acquirer.id == null || acquirer.id == '') {

                addNew = true;
            }

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: SaveAcquirerAction, acquirer: resp.result, addNew });
                    return resp.result;

                } else {

                    throw new Error(resp.error_message || '登録に失敗しました。');

                }
            } else {
                throw new Error('登録に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 編集用のモデルをロードします。
     */
    loadEditModel: (token, acquirerId) => async (dispatch) => {
        var routeurl = `api/user/merchants/edit`;

        if (acquirerId != null) {
            routeurl += `?id=${acquirerId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })
            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    const acquirer = resp.result;
                    dispatch({ type: ModifyAcquirerAction, acquirer });
                    return acquirer;
                } else {
                    throw new Error(resp.error_message || '加盟店情報取得に失敗しました。');
                }
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * Get Merchant category code
     * 
     */
    merchantCategoryCode: (token) => async (dispatch) => {
        var routeurl = `api/user/merchants/categorylist`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })
            const resultStatus = response.status;
            if (resultStatus == 200) {
                const code = await response.json();
                dispatch({ type: MerchantCategotyCodeAction, code });
                return code;
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 加盟店の申請を更新
     */
    update: (token, acquirer) => async (dispatch) => {
        var routeurl = `api/user/merchants/update`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(acquirer)
            })
            var addNew = true;

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: SaveAcquirerAction, acquirer: resp.result });
                    return resp.result;

                } else {

                    throw new Error(resp.error_message || '更新に失敗しました。');

                }
            } else {
                throw new Error('更新に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 加盟店の申請を承認
     */
    approve: (token, acquirer) => async (dispatch) => {
        var routeurl = `api/user/merchants/approve`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(acquirer)
            })
            var addNew = true;

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: SaveAcquirerAction, acquirer: resp.result });
                    return resp.result;

                } else {

                    throw new Error(resp.error_message || '申請の承認に失敗しました。');

                }
            } else {
                throw new Error('申請の承認に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 加盟店申請を削除します。
     */
    delete: (token, acquirer) => async (dispatch) => {
        var routeurl = `api/user/merchants`;

        if (acquirer.id != null) {
            routeurl += `?id=${acquirer.id}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'delete',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                }
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: DeleteAcquirerAction, acquirer: resp.result });
                    return resp.result;

                } else {
                    throw new Error(resp.error_message || '申請削除に失敗しました。');
                }
            } else {
                throw new Error('申請削除に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 代表加盟店を解約します。
     */
    cancellation: (token, acquirer, cancelReason) => async (dispatch) => {
        var routeurl = `api/user/merchants/cancellation_acquirer`;

        if (acquirer.id != null && cancelReason != null) {
            routeurl += `?id=${acquirer.id}&cancelReason=${cancelReason}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(acquirer)
            })

            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    dispatch({ type: SaveAcquirerAction, acquirer: resp.result });
                    return resp.result;
                } else {
                    throw new Error(resp.error_message || '解約に失敗しました。');
                }
            } else {
                throw new Error('解約に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },
}

export const reducer = (state, action) => {
    state = state || initialState;
    
    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ModifyAcquirerAction) {
        return {
            ...state,
            editing: action.acquirer,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListAcquirersAction) {
        return {
            ...state,
            list: action.list,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === SaveAcquirerAction) {

        if (action.addNew) {
            // 代表加盟店の新規登録時の場合はリストに追加
            state.list.push(action.acquirer);
        }
        else {
            // 変更の場合はリストを変更
            var idx = state.list.findIndex((o) => o.id == action.acquirer.id);
            state.list[idx] = action.acquirer;
        }

        return {
            ...state,
            editing: action.acquirer
        };
    }
    if (action.type === MerchantCategotyCodeAction) {
        return {
            ...state,
            code: action.code,
        }
    }
    // 削除
    if (action.type === DeleteAcquirerAction) {
        // 削除の場合はリストから除去
        state.list = state.list.filter((o) => o.id != action.acquirer.id);

        return {
            ...state,
            editing: action.acquirer
        };
    }
    return state;
}